// src/pages/ChatWithAI/components/SourcesAccordion.js
import React, { useMemo, useState } from 'react';

const normalize = (sources) => {
  if (!Array.isArray(sources)) return [];
  const mapped = sources
    .map((s) => {
      if (!s) return null;
      const url = s.url || s.uri || s.link;
      if (!url) return null;
      const title = s.title || s.name || url;
      return { title, url };
    })
    .filter(Boolean);

  // dedup por url
  return Array.from(new Map(mapped.map((x) => [x.url, x])).values());
};

export default function SourcesAccordion({ sources = [] }) {
  const [open, setOpen] = useState(false);

  const items = useMemo(() => normalize(sources), [sources]);
  if (!items.length) return null;

  return (
    <div className={`sources-accordion ${open ? 'open' : 'closed'}`}>
      <button
        type="button"
        className="sources-accordion__header"
        onClick={() => setOpen((v) => !v)}
        title={open ? 'Ocultar fontes' : 'Mostrar fontes'}
      >
        <span className="sources-accordion__title">
          🔗 Fontes consultadas ({items.length})
        </span>
        <span className="sources-accordion__chevron" aria-hidden="true">
          {open ? '▾' : '▸'}
        </span>
      </button>

      {open && (
        <div className="sources-accordion__body">
          {items.map((s, idx) => (
            <div key={`${s.url}-${idx}`} className="sources-accordion__item">
              <span className="sources-accordion__icon">🌐</span>
              <a
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                className="sources-accordion__link"
                title={s.title}
              >
                {s.title}
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
